export default function useUrlQuery(location, keys = [] as any) {
  const urlParams = new URLSearchParams(location.search)
  let urlData = {} as any
  keys.forEach(key => {
    urlData[key] = urlParams.get(key)
  })
  return urlData
}
